import { createI18n } from 'vue-i18n'
import en from '../i18n/en';
import ja from '../i18n/ja';
import pt from '../i18n/pt';

export const SUPPORTED_LOCALES = ["en", "ja", "pt"];
export const DEFAULT_LOCALE = "pt";

export const resolveInitialLocale = () => {
    const storedLocale =
        typeof localStorage !== "undefined"
            ? localStorage.getItem("selectedLanguage")
            : null;
    if (SUPPORTED_LOCALES.includes(storedLocale)) {
        return storedLocale;
    }

    return DEFAULT_LOCALE;
};

const i18nOptions = {
    legacy: false, // for Vue 3
    locale: resolveInitialLocale(),
    fallbackLocale: DEFAULT_LOCALE,
    globalInjection: true, // enable global injection
    messages: {
        en,
        ja,
        pt,
    },
};

const createSafeI18n = () => {
    if (typeof createI18n === 'function') {
        return createI18n(i18nOptions);
    }
    // Jest mocks can strip createI18n; provide minimal fallback so tests keep running.
    const fallbackGlobal = {
        locale: i18nOptions.locale,
        fallbackLocale: i18nOptions.fallbackLocale,
        messages: i18nOptions.messages,
        t: (key) => key,
        tm: () => ({}),
        te: () => false,
        n: (value) => value,
    };
    return { global: fallbackGlobal };
};

export const i18n = createSafeI18n();

export default ({ app }) => {
    app.use(i18n);
};
